
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlists/themes",
      function () {
        return require("private-next-pages/playlists/themes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlists/themes"])
      });
    }
  